<template>
  <vx-card class="mx-2 w-full">
    <div class="text-center w-full">
      <div class="flex justify-around w-1/2 mx-auto">
        <h2 class="text-4xl text-success" v-if="!loading">{{count}}</h2>
        <div v-else class="text-center py-1">
          <spinner size="29" line-fg-color="#0DA8CD"></spinner>
        </div>
        <feather-icon :icon="icon" svg-classes="text-primary" />
      </div>
      <router-link :to="url">{{status}}</router-link>
    </div>
    
  </vx-card>
</template>

<script>
import Spinner from 'vue-simple-spinner'
export default {
  name: 'order-status-card',
  props: {
    status: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'InboxIcon'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Spinner
  }
}
</script>